import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {
  Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js';
import moment from 'moment'
import {
  BasicSelect
} from 'vue-search-select';
import VueElementLoading from 'vue-element-loading';
import Printd from 'printd';
import Multiselect from 'vue-multiselect'

export default {
  name: 'generate-vehicle-trip-print',
  components: {
    Paginate,
    DatePicker,
    BasicSelect,
    VueElementLoading,
    Multiselect
  },
  data: function() {
    return {
      hubzonelist: [],
      hubzoneitem: {
				id: '',
				text: ''
			},
      hubzone: '',
      hubzoneLoading: '',
      hublist: [],
      hubitem: {
				value: '',
				text: ''
			},
      hub: '',
      hubLoading:'',
      BagList: [],
      totalRows:0,
      pageNo: 0,
      limit: 10,
      hubid: 0,
      isLoadingSearch: false,
      showTable: false,
      isLoading: false,
      FromDate:'',
      ToDate:'',
      hubObj:[]
    }
  },
  created: function() {},
  computed: {},
  filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).utc().format('DD-MM-YYYY HH:mm:ss');
    },

  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext)
    this.createdBy = userdetail[0].email;
    this.PrintBy = this.createdBy;
    this.PrintDate = new Date();
    this.hubid = userdetail[0].HubId;
    this.getHubZone();
  },
  methods: {

    getHubZone() {
      this.hubzoneLoading = 'Loading Hub Zone...'
      var i = 0;
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      this.input = ({
        // hubName: this.hubzoneitem.id,
      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'hubzone/list',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.hubzoneLoading = ''
          this.HubZoneListData = result.data.ResponseData;
          for (i = 0; i < this.HubZoneListData.length; i++) {
            this.hubzonelist.push({
              id: this.HubZoneListData[i].hubzoneid,
              text: this.HubZoneListData[i].hubzonename
            })
          }
        }, error => {
          console.error(error)
        })
    },
    selectHubZone(hubzoneitem) {
      this.hubzoneitem = hubzoneitem
      this.hubzone = this.hubzoneitem.text
      this.hubzoneid = this.hubzoneitem.id
      this.hubObj=[]
      this.$validator.reset('Hub')

      if (this.hubzoneid != undefined) {
        this.getHubList(this.hubzoneid)
      }
    },

    getHubList() {
      this.hubLoading = 'Loading Hub...'
      this.input = ({
        hubZoneId: this.hubzoneid
      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'hubservicecenter/hub/list',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.hubLoading = ''
          this.HubDetails = []
          this.hublist=[]
          for (var i = 0; i < result.data.ResponseData.length; i++) {
            this.hublist.push({
              "value": result.data.ResponseData[i].HubID,
              "text": result.data.ResponseData[i].HubName + '(' + result.data.ResponseData[i].HubID + ')',
            })
          }
        }, error => {
          console.error(error)
        })
    },

    selectHub(hubitem) {
			this.hubitem = hubitem
			this.hub = hubitem.value
		},
    checkToDate() {
      var date1 = new Date(this.FromDate);
      date1.setDate(date1.getDate() + 30)
      this.validDateRange = date1

      var date2 = new Date(this.ToDate);
      date2.setDate(date2.getDate() + 30)
      this.validDateRange = date2

        },
    fetchBagDetailsByGroup() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.FromDate = moment(this.FromDate).format('YYYY-MM-DD')
          this.ToDate = moment(this.ToDate).format('YYYY-MM-DD')
          this.isLoading = true
          this.input = ({
            hubId: this.hub,
            fromDate:this.FromDate,
            toDate:this.ToDate
          })
          axios({
              method: 'POST',
              'url': apiUrl.api_url_hubops + 'fetchBagDetailsByGroup',
              'data': this.input,
              headers: {
                'Authorization': 'authkey xB84JJ89Hd25'
              }
            })
            .then(result => {
              if (result.data.ResultCode == 100) {
                this.showTable = true;
                this.BagList = result.data.ResponseData;
                this.totalRows=this.BagList.length

                if (this.totalRows < 10) {
                  this.pageCount = 1
                } else {
                  this.pageCount = Math.ceil(this.totalRows / 10);
                }
              } else if (result.data.ResultCode == 101) {
                this.BagList = [];
                this.showTable = false;
                this.$alertify.error(result.data.ReturnMessage)
              } else {
                this.BagList = [];
                this.showTable = false;
                this.$alertify.error(result.data.ReturnMessage.name)
              }
              this.isLoading = false
            }, error => {
              this.isLoadingSearch = false;
              this.isLoading = false
              console.error(error)
            })
        }
      });
    },
    // printSheet() {
    //   const d = new Printd();
    //   var buffer = '';
    //
    //   var cssText = `
    //        body{
    //            -webkit-print-color-adjust:exact;
    //            font-family: Roboto,sans-serif;
    //        }
    //        table {
    //            border-collapse: collapse;
    //            margin-left:0px !important;
    //        }
    //        table, td, th {
    //          border-style: solid;
    //          border-width: 1px;
    //          padding:5px;
    //        }
    //        .text-right{
    //          text-align:right;
    //        }
    //        .text-left{
    //          text-align:left;
    //        }
    //        .text-center{
    //          text-align:center;
    //        }
    //        .h3-center-text{
    //          text-align:center;
    //        }
    //        @media print {
    //        .text-primary th{
    //          background-color:rgb(226, 216, 216) !important;
    //          color:black !important;
    //          font-size:20px !important;
    //        }
    //       }
    //       `
    //   d.print(document.getElementById('PrintSheet'), cssText);
    // },
    getPaginationData(pageNum) {
      this.pageNo = (pageNum - 1)
      this.fetchBagDetailsByGroup()
    },

    resetForm() {
      this.hubzoneitem={};
      this.hubitem='';
      this.hubzoneid='';
      this.hub='';
      this.FromDate = '';
      this.ToDate = '';
      this.bagDetails = {};
      this.pageNo = 0;
      this.showModal = false;
      this.tripSheetData ={};
      this.ResponseData = [];
      this.showTable = false;
      this.$validator.reset();
      this.errors.clear();
      this.hubObj=[]
    },
  }
}



// WEBPACK FOOTER //
// ./src/views/components/BagDetailsByHub/BagDetailsByHub.js